export default __webpack_public_path__ + "79c5f87752f2c9b3cfd20848684b8e06.png";